import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import DebitCreditAddForm from "../../components/DebitCredit/Add/DebitCreditAddForm";
import { withRouter } from "react-router";
import { client } from "../../service/ApolloClient/ApolloClient";
import { ErrorToast } from "../../hoc/ToastNotify/ToastNotify";
import { QUERY_DEBIT_CREDIT } from "../../service/ApolloClient/ApolloQueries";
import DebitCreditListAttachment from "./DebitCreditListAttachment";

export const DEBIT_CREDIT_SELECT_EDIT = "DEBIT_CREDIT_SELECT_EDIT";
export const CAR_CONTRACT_SELECT_ATTACHMENT = "CAR_CONTRACT_SELECT_ATTACHMENT";

class DebitCreditEditPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id,
      data: null,
      loading: true,
      pageSelect: DEBIT_CREDIT_SELECT_EDIT,
    };

    this.handleSelectPage = this.handleSelectPage.bind(this);
    this.loadPage = this.loadPage.bind(this);
  }

  componentDidMount() {
    this.loadPage();
  }

  loadPage() {
    this.setState({
      loading: true,
    });

    client
      .query({
        query: QUERY_DEBIT_CREDIT,
        variables: {
          id: parseInt(this.state.id),
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = res.data.debtCredit;

        this.setState({
          loading: false,
          data: data,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          data: null,
        });
        ErrorToast("مشکل در دریافت اطلاعات");
      });
  }

  handleSelectPage(page) {
    this.setState({
      pageSelect: page,
    });
  }

  render() {
    const { loading, data, pageSelect } = this.state;

    let componentSelect = <Wrapper>در حال بارگزاری</Wrapper>;

    if (pageSelect === DEBIT_CREDIT_SELECT_EDIT) {
      componentSelect = (
        <DebitCreditAddForm
          handleSelectPage={this.handleSelectPage}
          data={data}
          isEdit={true}
        />
      );
    } else if (pageSelect === CAR_CONTRACT_SELECT_ATTACHMENT) {
      componentSelect = (
        <DebitCreditListAttachment
          carContract={data}
          handleBack={() => {
            this.handleSelectPage(DEBIT_CREDIT_SELECT_EDIT);
          }}
        />
      );
    }

    return (
      <Wrapper>
        <BreadcrumbsTemp
          items={[
            {
              title: "ویرایش بدهکار بستانکار ",
              to: "/debit-credit/edit",
            },
          ]}
        />

        <Grid container={true}>
          <Grid item xs={12}>
            {loading ? (
              <Wrapper>در حال بارگزاری</Wrapper>
            ) : data === null ? (
              <Wrapper>اطلاعاتی برای نمایش نیست</Wrapper>
            ) : (
              componentSelect
            )}
          </Grid>
        </Grid>
      </Wrapper>
    );
  }
}

export default withRouter(DebitCreditEditPage);
